// Preloader — hide as soon as the DOM is ready instead of waiting for every
// image, analytics request, or third-party script on the page.
function hidePreloader() {
    var fadeout = document.getElementById('fadeout');
    if (fadeout) {
        fadeout.classList.add('loaded');
        setTimeout(function () {
            fadeout.style.display = 'none';
        }, 300);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidePreloader, { once: true });
} else {
    hidePreloader();
}

// Navigate between nav sections on page
const handleScroll = (e) => {
    let element = e.target,
        type_element = element.localName;

    if (element.classList.contains('nav-link') && !element.classList.contains('nav-link-lang')) {
        e.preventDefault();
        document.querySelectorAll('#navbarToggler li').forEach(item => item.classList.remove('active'));
        if (element.closest('li')) element.closest('li').classList.add('active');
    }

    if (element.id === 'create-qr') {
        window.location.href = element.href;
        return false;
    }

    if (type_element == 'img') {
        element = element.closest('a');
    }

    const targetId = element.getAttribute('href');

    if (!targetId || !targetId.startsWith('#')) return;

    const targetElement = document.querySelector(targetId);

    if (targetElement) {
        const offset = 88;
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

if (document.querySelector('.page-home')) {
    const navItems = document.querySelectorAll('header .navbar-nav li a');
    navItems.forEach(item => item.addEventListener('click', handleScroll));
}

const btnRegister = document.querySelectorAll('.cta-register');
if (btnRegister) {
    btnRegister.forEach(item => item.addEventListener('click', handleScroll));
}

// ===================================
// NEW FRONTEND BEHAVIORS
// ===================================

document.addEventListener('DOMContentLoaded', function() {

    // 1. THEME TOGGLE
    (function initTheme() {
        var toggle = document.getElementById('theme-toggle');
        if (!toggle) return;

        toggle.addEventListener('click', function() {
            var current = document.documentElement.getAttribute('data-theme') || 'light';
            var next = current === 'light' ? 'dark' : 'light';
            document.documentElement.setAttribute('data-theme', next);
            document.documentElement.style.colorScheme = next;
            try {
                localStorage.setItem('theme', next);
            } catch(e) {}
            var metaTheme = document.querySelector('meta[name="theme-color"]');
            if (metaTheme) {
                metaTheme.setAttribute('content', next === 'dark' ? '#0f172a' : '#ffffff');
            }
        });
    })();

    // 2. STICKY HEADER
    (function initStickyHeader() {
        var header = document.getElementById('header');
        if (!header) return;

        var ticking = false;
        function updateHeader() {
            if (window.pageYOffset > 20) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
            ticking = false;
        }

        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(updateHeader);
                ticking = true;
            }
        }, { passive: true });
    })();

    // 3. MOBILE NAV
    (function initMobileNav() {
        var toggle = document.getElementById('nav-toggle');
        var menu = document.getElementById('nav-menu');
        var overlay = document.getElementById('nav-overlay');

        if (!toggle || !menu) return;

        function openMenu() {
            toggle.classList.add('active');
            menu.classList.add('active');
            if (overlay) {
                overlay.classList.add('active');
                overlay.removeAttribute('aria-hidden');
            }
            document.body.classList.add('no-scroll');
            toggle.setAttribute('aria-expanded', 'true');
            toggle.setAttribute('aria-label', 'Cerrar menú');
        }

        function closeMenu() {
            toggle.classList.remove('active');
            menu.classList.remove('active');
            if (overlay) {
                overlay.classList.remove('active');
                overlay.setAttribute('aria-hidden', 'true');
            }
            document.body.classList.remove('no-scroll');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Abrir menú');
        }

        toggle.addEventListener('click', function(e) {
            e.stopPropagation();
            if (menu.classList.contains('active')) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        if (overlay) {
            overlay.addEventListener('click', closeMenu);
        }

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && menu.classList.contains('active')) {
                closeMenu();
            }
        });

        window.addEventListener('resize', function() {
            if (window.innerWidth > 768 && menu.classList.contains('active')) {
                closeMenu();
            }
        });

        // Close on nav link click (mobile)
        menu.querySelectorAll('.nav__link').forEach(function(link) {
            link.addEventListener('click', function() {
                if (window.innerWidth <= 768) {
                    closeMenu();
                }
            });
        });
    })();

    // 4. SMOOTH SCROLL for anchor links
    (function initSmoothScroll() {
        var headerOffset = 88;

        function scrollToTarget(target) {
            var pos = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({ top: pos, behavior: 'smooth' });
        }

        document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
            anchor.addEventListener('click', function(e) {
                var href = this.getAttribute('href');
                if (!href || href === '#' || href === '') return;
                var target = document.querySelector(href);
                if (target) {
                    // Section exists on this page — smooth scroll
                    e.preventDefault();
                    scrollToTarget(target);
                    try { history.pushState(null, null, href); } catch(err) {}
                } else {
                    // Section not on this page — navigate to home with hash
                    e.preventDefault();
                    window.location.href = '/' + href;
                }
            });
        });
    })();

    // 5. FAQ ACCORDION
    (function initFAQ() {
        var faqItems = document.querySelectorAll('.faq-item');
        if (!faqItems.length) return;

        faqItems.forEach(function(item) {
            var question = item.querySelector('.faq-question');
            if (!question) return;

            question.addEventListener('click', function() {
                var isActive = item.classList.contains('active');

                // Close all
                faqItems.forEach(function(i) {
                    i.classList.remove('active');
                    var ic = i.querySelector('.faq-icon');
                    var q  = i.querySelector('.faq-question');
                    if (ic) ic.textContent = '+';
                    if (q)  q.setAttribute('aria-expanded', 'false');
                });

                // Open current if it was closed
                if (!isActive) {
                    item.classList.add('active');
                    var icon = item.querySelector('.faq-icon');
                    if (icon) icon.textContent = '×';
                    question.setAttribute('aria-expanded', 'true');
                }
            });
        });
    })();

    // 6. AUTH TABS (for landing page #contact-us section)
    (function initAuthTabs() {
        var tabs = document.querySelectorAll('.auth-tab');
        var forms = document.querySelectorAll('.auth-form');

        if (!tabs.length) return;

        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                var targetTab = this.getAttribute('data-tab');

                tabs.forEach(function(t) {
                    t.classList.remove('active');
                    t.setAttribute('aria-selected', 'false');
                });
                this.classList.add('active');
                this.setAttribute('aria-selected', 'true');

                forms.forEach(function(form) { form.classList.remove('active'); });

                var targetForm = document.getElementById(targetTab + '-form');
                if (targetForm) targetForm.classList.add('active');
            });
        });
    })();

    // 7. LANG SWITCHER DROPDOWN
    (function initLangSwitcher() {
        var switcher = document.getElementById('lang-switcher');
        if (!switcher) return;

        switcher.addEventListener('click', function(e) {
            e.stopPropagation();
            var isOpen = switcher.classList.toggle('open');
            switcher.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        // Close on outside click
        document.addEventListener('click', function() {
            switcher.classList.remove('open');
            switcher.setAttribute('aria-expanded', 'false');
        });

        // Keyboard support
        switcher.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                switcher.click();
            }
            if (e.key === 'Escape') {
                switcher.classList.remove('open');
                switcher.setAttribute('aria-expanded', 'false');
            }
        });
    })();

    // 8. SCROLL ANIMATIONS
    (function initScrollAnimations() {
        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile || !window.IntersectionObserver) return;

        var observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animated');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
            observer.observe(el);
        });

        // Animate decorative/content cards, but keep FAQ items visible immediately.
        // Hiding FAQ rows until IntersectionObserver fires makes fast scrolling
        // feel like the content is loading late.
        var animatedElements = document.querySelectorAll(
            '.service-card, .step, .pricing-card, .package-card, .contact-item'
        );

        animatedElements.forEach(function(el, index) {
            el.style.setProperty('--animation-delay', (index * 0.1) + 's');
        });

        if (!document.getElementById('animation-styles')) {
            var style = document.createElement('style');
            style.id = 'animation-styles';
            style.textContent = [
                '.service-card, .step, .pricing-card, .package-card, .contact-item {',
                '    opacity: 0;',
                '    transform: translateY(30px);',
                '    transition: opacity 0.6s ease-out var(--animation-delay, 0s), transform 0.6s ease-out var(--animation-delay, 0s);',
                '}',
                '.animate-in, .animated {',
                '    opacity: 1 !important;',
                '    transform: translateY(0) !important;',
                '}'
            ].join('\n');
            document.head.appendChild(style);

            var scrollObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        scrollObserver.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            animatedElements.forEach(function(el) {
                scrollObserver.observe(el);
            });
        }
    })();

    // 9. ACTIVE NAV LINK ON SCROLL
    (function initActiveNav() {
        var sections = document.querySelectorAll('section[id]');
        var navLinks = document.querySelectorAll('.nav__link');
        if (!sections.length || !navLinks.length) return;

        var observerOptions = {
            root: null,
            rootMargin: '-20% 0px -70% 0px',
            threshold: 0
        };

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var id = entry.target.getAttribute('id');
                    navLinks.forEach(function(link) {
                        link.classList.remove('active');
                        var href = link.getAttribute('href');
                        if (href && (href === '#' + id || href.endsWith('/#' + id))) {
                            link.classList.add('active');
                        }
                    });
                }
            });
        }, observerOptions);

        sections.forEach(function(section) { observer.observe(section); });
    })();

});
